import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime-corejs3/helpers/createForOfIteratorHelper";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _createSuper from "@babel/runtime-corejs3/helpers/createSuper";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import EventEmitter from "./EventEmitter";
var MemoryCache = /*#__PURE__*/function (_EventEmitter) {
  _inherits(MemoryCache, _EventEmitter);
  var _super = _createSuper(MemoryCache);
  function MemoryCache() {
    var _this;
    _classCallCheck(this, MemoryCache);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_ready", true);
    _defineProperty(_assertThisInitialized(_this), "_records", new Map());
    _defineProperty(_assertThisInitialized(_this), "_maxCacheTime", MemoryCache.DEFAULT_MAX_CACHE_TIME);
    _defineProperty(_assertThisInitialized(_this), "_defaultCacheTime", MemoryCache.DEFAULT_CACHE_TIME);
    return _this;
  }
  _createClass(MemoryCache, [{
    key: "_checkCacheKey",
    value: function _checkCacheKey(key) {
      if (key == null) {
        throw new TypeError("Cache key can't be null or undefined. Received: ".concat(String(key), "."));
      }
    }
  }, {
    key: "_checkCacheData",
    value: function _checkCacheData(data) {
      if (data === undefined) {
        throw new TypeError("Cache data can't be undefined.");
      }
    }
  }, {
    key: "_setDeleteRecordTimer",
    value: function _setDeleteRecordTimer(key, cacheTime) {
      var _this2 = this;
      var timer = 0;
      if (cacheTime > 0 && cacheTime <= this._maxCacheTime && cacheTime < Number.MAX_SAFE_INTEGER) {
        timer = +setTimeout(function () {
          _this2["delete"](key);
        }, cacheTime);
      }
      return timer;
    }
  }, {
    key: "_clearDeleteRecordTimer",
    value: function _clearDeleteRecordTimer(key) {
      var record = this._records.get(key);
      if (record && record.deleteTimer) {
        clearTimeout(record.deleteTimer);
      }
    }
  }, {
    key: "isReady",
    value: function isReady() {
      return this._ready;
    }
  }, {
    key: "asReady",
    value: function asReady() {
      if (!this._ready) {
        this._ready = true;
        this.emit("ready");
      }
      return this;
    }
  }, {
    key: "getMaxCacheTime",
    value: function getMaxCacheTime() {
      return this._maxCacheTime;
    }
  }, {
    key: "setMaxCacheTime",
    value: function setMaxCacheTime(maxCacheTime) {
      this._maxCacheTime = maxCacheTime;
      return this;
    }
  }, {
    key: "getDefaultCacheTime",
    value: function getDefaultCacheTime() {
      return this._defaultCacheTime;
    }
  }, {
    key: "setDefaultCacheTime",
    value: function setDefaultCacheTime(defaultCacheTime) {
      this._defaultCacheTime = defaultCacheTime;
      return this;
    }
  }, {
    key: "memorize",
    value: function memorize(key, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this._checkCacheKey(key);
      this._checkCacheData(data);
      this._clearDeleteRecordTimer(key);
      var now = Date.now();
      var _options$cacheTimesta = options.cacheTimestamp,
        cacheTimestamp = _options$cacheTimesta === void 0 ? now : _options$cacheTimesta;
      var _options$cacheTime = options.cacheTime,
        cacheTime = _options$cacheTime === void 0 ? this._defaultCacheTime : _options$cacheTime;
      var remainingTime = cacheTimestamp - now + cacheTime;
      if (remainingTime > 0) {
        var deleteTimer = this._setDeleteRecordTimer(key, remainingTime);
        this._records.set(key, {
          data: data,
          cacheTime: cacheTime,
          deleteTimer: deleteTimer,
          cacheTimestamp: cacheTimestamp
        });
      } else {
        this._records["delete"](key);
      }
      return this;
    }
  }, {
    key: "set",
    value: function set(key, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this._checkCacheKey(key);
      this._checkCacheData(data);
      this._clearDeleteRecordTimer(key);
      var _options$cacheTime2 = options.cacheTime,
        cacheTime = _options$cacheTime2 === void 0 ? this._defaultCacheTime : _options$cacheTime2;
      if (cacheTime > 0) {
        this._records.set(key, {
          data: data,
          cacheTime: cacheTime,
          deleteTimer: this._setDeleteRecordTimer(key, cacheTime),
          cacheTimestamp: Date.now()
        });
        this["for"](key).emit("set", data);
        this.emit("set", key, data);
      } else {
        this["delete"](key);
      }
      return this;
    }
  }, {
    key: "has",
    value: function has(key) {
      return this._records.has(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      var _this$_records$get;
      return (_this$_records$get = this._records.get(key)) === null || _this$_records$get === void 0 ? void 0 : _this$_records$get.data;
    }
  }, {
    key: "getCacheTime",
    value: function getCacheTime(key) {
      var _this$_records$get2;
      return (_this$_records$get2 = this._records.get(key)) === null || _this$_records$get2 === void 0 ? void 0 : _this$_records$get2.cacheTime;
    }
  }, {
    key: "getCacheTimestamp",
    value: function getCacheTimestamp(key) {
      var _this$_records$get3;
      return (_this$_records$get3 = this._records.get(key)) === null || _this$_records$get3 === void 0 ? void 0 : _this$_records$get3.cacheTimestamp;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var record = this._records.get(key);
      if (record) {
        this._clearDeleteRecordTimer(key);
        this._records["delete"](key);
        this["for"](key).emit("delete", record.data);
        this.emit("delete", key, record.data);
      }
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      var records = new Map(this._records);
      this._records.clear();
      var _iterator = _createForOfIteratorHelper(records),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            record = _step$value[1];
          if (record.deleteTimer) {
            clearTimeout(record.deleteTimer);
          }
          this["for"](key).emit("delete", record.data);
          this.emit("delete", key, record.data);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.emit("clear");
      return this;
    }
  }]);
  return MemoryCache;
}(EventEmitter);
_defineProperty(MemoryCache, "DEFAULT_CACHE_TIME", 5 * 60 * 1000);
_defineProperty(MemoryCache, "DEFAULT_MAX_CACHE_TIME", Number.MAX_SAFE_INTEGER);
export default MemoryCache;